<template>
  <b-dd-item
    variant="primary" size="sm" class="mr-2" @click="onCheckRefundClick"
    :disabled="settlementPayment.payment.type === 'refund' || settlementPayment.check_status === 'cancelled'">
    <font-awesome-icon icon="undo" style="font-size: .9em" class="mr-1"/>
    {{ $t('Refund Payment') }}
  </b-dd-item>
</template>

<script>
  import PaymentModel from "@/modules/settlements/Payment.model";
  import {Formatter} from "@/core/services/formatter.service";
  import SettlementService from "@/modules/settlements/SettlementService";

  export default {
    name: "RefundPaymentDDItem",
    props: ['settlementPayment'],
    methods: {
      async onCheckRefundClick() {
        let success = await this.$confirm(
          this.$i18n.t("Are you sure you want to refund following payment?")
        );
        if (!success) {
          return
        }
        const {settlement_uuid, amount, check_uuid, bacs_uuid} = this.settlementPayment
        const requestData = new PaymentModel(this.settlementPayment.payment)
        requestData.type = 'refund'
        requestData.uuid = null
        requestData.date = Formatter.getNowAsDate()
        requestData.reference_number = this.settlementPayment.reference_number
        const settlement_payment = {settlement_uuid, amount: -amount}
        if (check_uuid) {
          settlement_payment['check_uuid'] = check_uuid
        }
        if (bacs_uuid) {
          settlement_payment['bacs_uuid'] = bacs_uuid
        }
        requestData.settlement_payments.push(settlement_payment)
        let response = await SettlementService.createPayment(requestData.toJSON())
        if (response.success) {
          this.$emit('success')
        } else {
          if (response.body.non_field_errors) {
            this.$errorDialog(response.body.non_field_errors[0]);
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>
